import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-1037",
  "use": "icon-1037-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-1037\" viewBox=\"0 0 16 16\" id=\"icon-1037\">\n  <path d=\"m5.857 9.48 2.906-4.37-1.85-3.78a.203.203 0 0 0-.367.006L.145 13.726a.202.202 0 0 0 .182.292l4.508-.013 1.69-3.142-.668-1.383zm9.969 3.219-2.011-4.204-4.739 4.467 6.566.028c.15 0 .248-.156.184-.291z\" />\n  <path d=\"m11.288 7.096 1.182-4.429-5.232 6.296 1.619.047-2.621 4.874 6.755-6.366z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol